import { IPromo } from 'model/IPromo';

export const SET_PROMOS = 'SET_PROMOS';

export const setPromosAction = (promos: IPromo[]) => ({
    type: SET_PROMOS,
    promos,
} as const);

type PromoActions =
    | ReturnType<typeof setPromosAction>;

export const promoReducer = (
    state: IPromo[] = [],
    action: PromoActions,
): IPromo[] => {
    switch (action.type) {
        case SET_PROMOS:
            return action.promos;
        default:
            return state;
    }
};
